import React from 'react';
import { ChevronRight } from 'react-bootstrap-icons';
import * as Styled from './LayoutHeader.styled';
import { LayoutHeaderProps } from '../../../types';
import { ToggleFilter } from '../../layouts-live-stream/ToggleFilter';

export const LayoutHeader: React.FC<LayoutHeaderProps> = ({
    title,
    itemCount,
    onSeeAll,
    padding,
    headingFontSize,
    marginTop,
    marginBottom,
    showToggle,
    selectedOption,
    setSelectedOption,
    isLivestream = false,
    hideSeeAll = false,
    isMobile = false
}) => {

    if (isMobile) {
        const countLabel = isLivestream
            ? (itemCount ?? 0) > 1 ? 'Events' : 'Event'
            : (itemCount ?? 0) > 1 ? 'Videos' : 'Video';

        if (isLivestream) {
            // Livestream mobile: filter left, see all right, same line
            return (
                <Styled.HeaderContainer padding={padding} marginTop={marginTop} marginBottom={marginBottom}>
                    <Styled.MobileHeaderCenter>
                        <Styled.MobileHeaderLeft>
                            {title && <Styled.MobileHeading>{title}</Styled.MobileHeading>}
                            {itemCount !== undefined && (
                                <Styled.MobileCount>{itemCount} {countLabel}</Styled.MobileCount>
                            )}
                        </Styled.MobileHeaderLeft>
                        <Styled.MobileHeaderRight>
                            {!hideSeeAll && (
                                <Styled.SeeAllButton onClick={onSeeAll} isMobile={isMobile}>
                                    See all
                                </Styled.SeeAllButton>
                            )}
                        </Styled.MobileHeaderRight>
                    </Styled.MobileHeaderCenter>
                    <Styled.MobileFilterRow>
                        {showToggle && (
                            <ToggleFilter
                                selectedOption={selectedOption}
                                onChange={setSelectedOption}
                            />
                        )}
                    </Styled.MobileFilterRow>
                </Styled.HeaderContainer>
            );
        }

        // VOD mobile: centered title, count below, see all button below
        return (
            <Styled.HeaderContainer padding={padding} marginTop={marginTop} marginBottom={marginBottom}>
                <Styled.MobileHeaderCenter>
                    <Styled.MobileHeaderLeft>
                        {title && <Styled.MobileHeading>{title}</Styled.MobileHeading>}
                        {itemCount !== undefined && (
                            <Styled.MobileCount>{itemCount} {countLabel}</Styled.MobileCount>
                        )}
                    </Styled.MobileHeaderLeft>
                    <Styled.MobileHeaderRight>

                        {!hideSeeAll && (
                            <Styled.SeeAllButton onClick={onSeeAll} isMobile={isMobile}>
                                See all
                            </Styled.SeeAllButton>
                        )}
                    </Styled.MobileHeaderRight>
                </Styled.MobileHeaderCenter>
            </Styled.HeaderContainer>
        );
    }

    return (
        <Styled.HeaderContainer padding={padding} marginTop={marginTop} marginBottom={marginBottom}>
            <Styled.HeaderRow>

                {title && (
                    <Styled.Heading fontSize={headingFontSize}>
                        {title}
                        {itemCount !== undefined && <span>({itemCount} {isLivestream ? itemCount > 1 ? 'Events' : 'Event' : itemCount > 1 ? 'Videos' : 'Video'})</span>}
                    </Styled.Heading>
                )}
                <Styled.RightControls>
                    {showToggle && (
                        <ToggleFilter
                            selectedOption={selectedOption}
                            onChange={setSelectedOption}
                        />
                    )}
                    {!hideSeeAll && <Styled.SeeAllButton onClick={onSeeAll}>
                        See all <ChevronRight size={18} />
                    </Styled.SeeAllButton>}
                </Styled.RightControls>
            </Styled.HeaderRow>
        </Styled.HeaderContainer>

    );
};
